module.exports = require('./helpers/bundle-url').getBundleURL('bLxZJ') + "background-gradient-generator.f5564c70.png" + "?" + Date.now();